import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import './App.css';
import Button from './components/Button/Button.component';
import EmbedContainer from './components/EmbedContainer/EmbedContainer.component';
import FiltersContainer from './components/FiltersContainer/FiltersContainer.component';
import Footer from './components/Footer/Footer.compontent';
import GraphContainer from './components/GraphContainer/GraphContainer.component';
import Header from './components/Header/Header.component';
import SearchInput from './components/SearchInput/SearchInput.component';
import SharingContainer from './components/SharingContainer/SharingContainer.component';
import { defaultState, FilterContext } from './contexts/FilterContext';
import { QueryContext } from './contexts/QueryContext';
import { decodeStateToObject, encodeStateToArray } from './utils';

function App({ history }: any) {
	const [isModalShown, setIsModalShown] = useState(false);
	const [currentHash, setCurrentHash] = useState('');
	const [isError, setIsError] = useState(false);
	const [isPending, setIsPending] = useState(false);
	const [isHidden, setIsHidden] = useState<boolean>(true);
	const [graphData, setGraphData] = useState<
		{ key: string; values: { x: string; y: number }[] }[]
	>([]);
	const [rawFrequencyData, setRawFrequencyData] = useState<
		{ x: string; y: number; color: string }[]
	>([]);
	const [galaxyData, setGalaxyData] = useState({});
	const [extendedFrequencyData, setExtendedFrequencyData] = useState<
		{ x: string; y: number; color: string }[]
	>([]);

	const [filters, setFilters] = useContext(FilterContext);
	const [queryString] = useContext(QueryContext);

	const colors = [
		'#00579E',
		'#9A515E',
		'#328089',
		'#657683',
		'#BF8634',
		'#669AC5',
		'#023055',
		'#571F29',
		'#014148',
		'#A7B1B9',
	];

	const fetchGraphData = async (query: string) => {
		setIsPending(true);
		const response = await fetch(query);
		const data = await response.json();

		if (filters.graphViewmode === 'råfrekvens') {
			try {
				let temporaryGraphDataArray: {
					x: string;
					y: number;
					color: string;
				}[] = [];
				// eslint-disable-next-line array-callback-return
				data.map(({ values }: any) => {
					if (values.length) {
						const valuesArray = [
							...values.map(
								({
									label,
									value,
								}: {
									label: string;
									value: number;
								}) => ({ x: label, y: value }),
							),
						];
						temporaryGraphDataArray = [
							...temporaryGraphDataArray,
							...valuesArray.slice(0, 10),
						];
						temporaryGraphDataArray.map(
							(
								value: { x: string; y: number; color: string },
								index: number,
							) => (value.color = colors[index]),
						);

						const temporaryExtendedValues = [
							...values.map(
								({
									label,
									value,
								}: {
									label: string;
									value: number;
								}) => ({ Ord: label, Frekvens: value }),
							),
						];
						setExtendedFrequencyData(temporaryExtendedValues);
					}
				});
				setRawFrequencyData(temporaryGraphDataArray);
			} catch {
				setIsError(true);
			}
		} else if (filters.graphViewmode === 'galakser') {
			try {
				setGalaxyData({});
				setGalaxyData(data);
			} catch {
				setIsError(true);
			}
		} else {
			try {
				setGraphData(data);
			} catch {
				setIsError(true);
			}
		}
		setIsPending(false);
	};

	useEffect(() => {
		setCurrentHash(window.location.hash);
	}, []);

	useEffect(() => {
		if (window.location.hash && window.location.hash !== currentHash) {
			const encodedFilters = window.location.hash.substring(1);
			const filterObject = decodeStateToObject(encodedFilters);
			setFilters(filterObject);
		} else {
			setFilters(defaultState);
		}
	}, [window.location.hash]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		encodeStateToArray(filters);
		decodeStateToObject(encodeStateToArray(filters));
	}, [filters]);

	useEffect(() => {
		fetchGraphData(queryString).catch(() => setIsError(true));
	}, [queryString]); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		const encodedFilters = encodeStateToArray(filters);
		window.location.hash = '#' + encodedFilters;
	}, [filters]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{!filters.isEmbedded && (
				<Header
					graphData={graphData}
					rawFrequencyData={rawFrequencyData}
				/>
			)}
			<div
				className={`${filters.isEmbedded && 'embedded'} ${
					isModalShown && 'modal-shown'
				} App`}
			>
				{!filters.isEmbedded ? (
					<>
						<div className="search-wrapper">
							<div>
								<Button
									borderLess
									className={`${!isHidden && 'is-open'}`}
									buttonLabel={`${
										isHidden ? 'Vis filter' : 'Skjul filter'
									}`}
									onClick={() => setIsHidden(!isHidden)}
								/>
								<Button
									buttonLabel="Nullstill"
									className={` clear-button ${
										isHidden && 'is-button-hidden'
									}`}
									onClick={() => setFilters(defaultState)}
								/>
							</div>
							<SearchInput showChips />
						</div>
						<div
							className={`ui-wrapper ${
								isHidden && 'filters-hidden'
							}`}
						>
							<FiltersContainer isHidden={isHidden} />
							<GraphContainer
								isPending={isPending}
								isError={isError}
								setIsError={setIsError}
								isFilterContainerHidden={isHidden}
								graphData={graphData}
								rawFrequencyData={rawFrequencyData}
								extendedFrequencyData={extendedFrequencyData}
								galaxyData={galaxyData}
								colors={colors}
							/>
						</div>
					</>
				) : (
					<EmbedContainer
						isPending={isPending}
						isError={isError}
						setIsError={setIsError}
						isFilterContainerHidden={isHidden}
						graphData={graphData}
						rawFrequencyData={rawFrequencyData}
						extendedFrequencyData={extendedFrequencyData}
						galaxyData={galaxyData}
						colors={colors}
					/>
				)}
			</div>
			{!filters.isEmbedded && (
				<>
					<SharingContainer
						isFilterContainerHidden={!isHidden}
						graphData={graphData}
						rawFrequencyData={rawFrequencyData}
						isModalShown={isModalShown}
						setIsModalShown={setIsModalShown}
					/>
					<Footer />
				</>
			)}
		</>
	);
}

export default withRouter(App);
